import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IAccessAlertAdmin, ILinkedAccountInfo, IUserAccessResponse } from '../../models/access';

export const AccessActions = createActionGroup({
  source: 'Access',
  events: {
    // User access loading actions
    'Load User Access': emptyProps(),
    'Load User Access Success': props<{ accessData: IUserAccessResponse }>(),
    'Load User Access Failure': props<{ error: any }>(),

    //Used to supply the IAccessContext with the guardian IDs
    'Load GuardianIds': props<{ guardianLinks: ILinkedAccountInfo[] }>(),

    'Load Guardian Links': props<{ guardianLinks: ILinkedAccountInfo[] }>(),

    // Current context actions
    'Set Current Context': props<{
      componentName?: string;
      studentId?: string;
      guardianId?: string;
    }>(),

    'Set Selected Account Codes': props<{ selectedAccountCodes: string[] }>(),

    'Clear Current Context': emptyProps(),

    'Set Access Alert Admin': props<{ accessAlertAdmin: IAccessAlertAdmin }>(),
    'Clear Access Alert Admin': emptyProps(),

    // Data management actions
    'Clear Access Data': emptyProps(),
    'Clear User Access': emptyProps(),
  },
});
